// i18n bootstrap for the guest self-service app.
//
// Mirrors the booking_engine_frontend/src/i18n/index.ts setup so CI
// gap-checks can compare both repos against the canonical English bundle.
//
// Resolution chain:
//   1. ?lang=xx  query param          (deep links from hotel websites)
//   2. localStorage ('i18nextLng')    (returning browsers)
//   3. navigator.language             (browser preference)
//   4. fallbackLng = 'en'
//
// Translation files live under public/locales/{lng}/{namespace}.json
// and are lazy-loaded the first time a namespace is touched.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

export const SUPPORTED_LANGUAGES = [
  { code: 'en',  label: 'English',    nativeLabel: 'English' },
  { code: 'lt',  label: 'Lithuanian', nativeLabel: 'Lietuvių' },
  { code: 'fil', label: 'Filipino',   nativeLabel: 'Filipino' },
];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    nonExplicitSupportedLngs: false,
    load: 'languageOnly',
    ns: ['guest'],
    defaultNS: 'guest',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',  // ?lang=lt deep links — matches booking engine
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    returnNull: false,
  });

export default i18n;
